import { render } from "./InBill.vue?vue&type=template&id=6dc7dfb4&scoped=true"
import script from "./InBill.vue?vue&type=script&lang=js"
export * from "./InBill.vue?vue&type=script&lang=js"

import "./InBill.vue?vue&type=style&index=0&id=6dc7dfb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc7dfb4"]])

export default __exports__